export const APP_VERSION = '2026.5';

export const APP_ENVIRONMENT = import.meta.env.PROD ? 'production' : 'development';

export const APP_DATASTORE = 'PostgreSQL 16';
